import { createContext, useContext, useReducer } from 'react';
import ajaxExpenses from '../util/remote/ajaxExpenses';
import ajaxIncome from '../util/remote/ajaxIncome';
import ajaxAsset from '../util/remote/ajaxAsset';
import ajaxLiability from '../util/remote/ajaxLiability';
import ajaxAccountChart from '../util/remote/ajaxAccountChart';

const initialState = { 
    expenseAccountListing: null,
    paymentAccountListing: null,
    incomeAccountListing: null,
    receiptAccountListing: null,
    accountsReceivableListing: null,
    assetAccountListing: null,
    liabilityAccountListing: null,
    chartOfAccounts: null,
    expanded: false,
    accountCategoryList: null,
    showOpeningBalanceModal: false,
    newAccountDraft: false,
    parentIncomeAccounts: null,
    parentExpenseAccounts: null,
    parentAssetLiabilityAccounts: null,
    accountsCatalogue: null,
    bankAccounts: null,

};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const AccountsContext = createContext();

export const AccountsProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  const getExpenseAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.expenseAccountListing)){
        return
    }
    dispatch({ type: 'expenseAccountListing', payload: null });
    const server_response  = await ajaxExpenses.listExpenseAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'expenseAccountListing', payload: server_response.details });
    }
  };

  const getPaymentAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.paymentAccountListing)){
        return
    }
    dispatch({ type: 'paymentAccountListing', payload: null });
    const server_response  = await ajaxExpenses.listPaymentAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'paymentAccountListing', payload: server_response.details });
    }
  };

  const getIncomeAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.incomeAccountListing)){
        return
    }
    dispatch({ type: 'incomeAccountListing', payload: null });
    const server_response  = await ajaxIncome.listIncomeAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'incomeAccountListing', payload: server_response.details });
    }
  };


  const getReceiptAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.receiptAccountListing)){
        return
    }
    dispatch({ type: 'receiptAccountListing', payload: null });
    const server_response  = await ajaxIncome.listPaymentAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'receiptAccountListing', payload: server_response.details });
    }
  };

  const getAssetAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.assetAccountListing)){
        return
    }
    dispatch({ type: 'assetAccountListing', payload: null });
    const server_response  = await ajaxAsset.listAssetAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'assetAccountListing', payload: server_response.details });
    }
  };

  const getLiabilityAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.liabilityAccountListing)){
        return
    }
    dispatch({ type: 'liabilityAccountListing', payload: null });
    const server_response  = await ajaxLiability.listLiabilityAccounts();
    if(server_response.status === "OK"){
        dispatch({ type: 'liabilityAccountListing', payload: server_response.details });
    }
  };


  const getChartOfAccounts = async (refresh) => {
    if(!refresh && Array.isArray(state.chartOfAccounts)){
        return
    }
    dispatch({ type: 'chartOfAccounts', payload: null });
    const server_response  = await ajaxAccountChart.fetchChart();
    if(server_response.status === "OK"){
        dispatch({ type: 'chartOfAccounts', payload: server_response.details });
    }else{
        dispatch({ type: 'chartOfAccounts', payload: '404' });

    }
  };

  const setChartofAccounts = (data)=>{
    dispatch({ type: 'chartOfAccounts', payload: data });
  }

  const setExpanded = (value) => {
    dispatch({ type: 'expanded', payload: value });
  }

  const getAccountCategories=async()=>{
    if(Array.isArray(state.accountCategoryList)){
      return
    }
    const server_response = await ajaxAccountChart.listAccountCategories();
    if(server_response.status==="OK"){
        dispatch({ type: 'accountCategoryList', payload: server_response.details });
    }
  }

  const toggleOpeningBalanceModal = (value)=>{
    dispatch({type: 'showOpeningBalanceModal', payload: value})
  }

  const getParentExpenseAccounts = async()=>{
    if(Array.isArray(state.parentExpenseAccounts)){
      return
    }
    const server_response = await ajaxAccountChart.fetchParentAccounts('2');
    if(server_response.status==="OK"){
        dispatch({ type: 'parentExpenseAccounts', payload: server_response.details });
    }else{
      dispatch({ type: 'parentExpenseAccounts', payload: server_response.details });

    }
  }

  const getParentIncomeAccounts = async()=>{
    if(Array.isArray(state.parentIncomeAccounts)){
      return
    }
    const server_response = await ajaxAccountChart.fetchParentAccounts('1');
    if(server_response.status==="OK"){
        dispatch({ type: 'parentIncomeAccounts', payload: server_response.details });
    }else{
      dispatch({ type: 'parentIncomeAccounts', payload: server_response.details });

    }
  }

  const getParentAssetLiabilityAccounts = async()=>{
    if(Array.isArray(state.parentAssetLiabilityAccounts)){
      return
    }
    const server_response = await ajaxAccountChart.fetchParentAccounts('3, 4');
    if(server_response.status==="OK"){
        dispatch({ type: 'parentAssetLiabilityAccounts', payload: server_response.details });
    }else{
      dispatch({ type: 'parentAssetLiabilityAccounts', payload: server_response.details });

    }
  }


  const getAccountsReceivable=async(refresh)=>{
    if(!refresh && Array.isArray(state.accountsReceivableListing)){
      return
    }
    dispatch({ type: 'accountsReceivableListing', payload: null });
    const server_response = await ajaxAsset.fetchAccountsReceivable();
    if(server_response.status === "OK"){
        dispatch({ type: 'accountsReceivableListing', payload: server_response.details });
    }
}

const getAllAccounts=async(refresh)=>{
  if(!refresh && Array.isArray(state.accountsCatalogue)){
    return
  }
  dispatch({ type: 'accountsCatalogue', payload: null });
  const server_response = await ajaxAccountChart.fetchAllAccounts();
  if(server_response.status === "OK"){
      dispatch({ type: 'accountsCatalogue', payload: server_response.details });
  }else{
      dispatch({ type: 'accountsCatalogue', payload: "404" });
  }
}

const getBankAccounts=async(refresh)=>{
  if(!refresh && Array.isArray(state.bankAccounts)){
    return
  }
  dispatch({ type: 'bankAccounts', payload: null });
  const server_response = await ajaxAccountChart.fetchBankAccounts();
  if(server_response.status === "OK"){
      dispatch({ type: 'bankAccounts', payload: server_response.details });
  }else{
      dispatch({ type: 'bankAccounts', payload: "404" });
  }
}


/**
   * getPrimitiveAccountsByType('Asset')
   * Returns all primitive accounts (leaf nodes) under Asset/Liability/Equity.
   *
   * Notes:
   * - Uses `category_id` on each node (including leaf nodes).
   * - Safe to call even if chartOfAccounts is not loaded.
   */
  const getPrimitiveAccountsByType = (type) => {
    if (!type) return [];
    if (!Array.isArray(state.accountsCatalogue)) return [];

    const parentIds = new Set(
      state.accountsCatalogue
        .map((a) => String(a?.is_sub_account_of || '0'))
        .filter((pid) => pid !== '0' && pid !== '')
    );

    return state.accountsCatalogue
      .filter((a) => !parentIds.has(String(a?.account_id)))
      .filter((a) => String(a?.account_type) === String(type))
      .sort((a, b) => String(a?.account_number || '').localeCompare(String(b?.account_number || '')));
  };


  return(
    <AccountsContext.Provider value={{
      ...state, 
      dispatch, 
      getExpenseAccounts,
      getPaymentAccounts,
      getIncomeAccounts,
      getReceiptAccounts,
      getAssetAccounts,
      getLiabilityAccounts,
      getChartOfAccounts,
      setChartofAccounts,
      setExpanded,
      getAccountCategories,
      toggleOpeningBalanceModal,
      getParentExpenseAccounts,
      getParentIncomeAccounts,
      getParentAssetLiabilityAccounts,
      getAccountsReceivable,
      getAllAccounts,
      getBankAccounts,
      getPrimitiveAccountsByType
      }}>
      {children}
    </AccountsContext.Provider>
  )

}

export const useAccounts = ()=>useContext(AccountsContext);

